var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal-document"},[_c('a',{attrs:{"href":_vm.legalDocument.url,"target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('svg-icon',{attrs:{"name":"icon_document","size":"50","fill":_vm.teamsiteConfig.color}})],1),_vm._v(" "),_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6b4257","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegalDocument.vue
// module id = null
// module chunks = 